// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layoutRoot {
  display: flex;
  height: 100vh;
}

/*.containers {
  width: 82%;
}
*/
.appRoot {
  position: relative;
}

.appRootDiv {
  position: absolute;
}

.containersRoot {
  z-index: 1;
  width: 100%;
}

.loaderRoot {
  z-index: 1000;
  /* background-color: black;
  opacity: 0.3; */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* layout.css */

.layout-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.sidebar-fixed { 
  height: 100vh;
  background-color: #f8f9fa; /* optional */
  border-right: 1px solid #dee2e6;
  position: relative;
  z-index: 1;
}

.content-area {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 0.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/hocs/Layout/layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;;CAGC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb;iBACe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,aAAa;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".layoutRoot {\n  display: flex;\n  height: 100vh;\n}\n\n/*.containers {\n  width: 82%;\n}\n*/\n.appRoot {\n  position: relative;\n}\n\n.appRootDiv {\n  position: absolute;\n}\n\n.containersRoot {\n  z-index: 1;\n  width: 100%;\n}\n\n.loaderRoot {\n  z-index: 1000;\n  /* background-color: black;\n  opacity: 0.3; */\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* layout.css */\n\n.layout-container {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.sidebar-fixed { \n  height: 100vh;\n  background-color: #f8f9fa; /* optional */\n  border-right: 1px solid #dee2e6;\n  position: relative;\n  z-index: 1;\n}\n\n.content-area {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 0.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
